
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/baza-pracodawcow",
      function () {
        return require("private-next-pages/baza-pracodawcow.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/baza-pracodawcow"])
      });
    }
  